import { MixpanelInstance } from "./types";

let instance: MixpanelInstance | null = null;

export const analyticsService = (() => {
  return {
    async load(): Promise<MixpanelInstance | null> {
      if (instance) {
        return instance;
      }
      try {
        const mixpanelImport = await import("mixpanel-browser");
        instance = mixpanelImport.default;

        instance.init(process.env.REACT_APP_MIXPANEL_TOKEN ?? "", {
          persistence: "cookie",
          track_pageview: "full-url",
          api_host: process.env.REACT_APP_MIXPANEL_API_HOST,
        });

        return instance;
      } catch (error) {
        return null;
      }
    },

    track(event: string, properties?: Record<string, string>) {
      if (instance && !instance.has_opted_out_tracking()) {
        instance.track(event, properties);
      }
    },

    handleConsent(hasConsent: boolean) {
      if (!instance) {
        return;
      }

      if (hasConsent) {
        instance.opt_in_tracking({ track: () => false });
      } else {
        instance.opt_out_tracking();
        instance.reset();
      }
    },
  };
})();
